@if(unsavedChanges){
      <div class="alert alert-danger text-center" role="alert">
        There are {{unsavedChangesCount}} unsaved changes. Please remember to save before closing the browser.
        <button type="button" class="btn btn-danger" (click)="saveChanges()">Save all Changes</button>
      </div>
    }
<div>
      <mat-paginator [length]="dbService.dataSource.data.length"
                  [pageSize]="pageSize"
                  [pageSizeOptions]="pageSizeOptions"
                  (page)="onPageChange($event)">
      </mat-paginator>
      <table class="table-container" #matTable mat-table [dataSource]="dbService.dataSource">
        <ng-container matColumnDef="id">
          <th class="mat-header-cell" center mat-header-cell *matHeaderCellDef> Event ID </th>
          <td class="mat-cell" mat-cell center *matCellDef="let element"> {{element.eventid}} </td>
        </ng-container>
        <ng-container matColumnDef="myname">
          <th class="mat-header-cell" center mat-header-cell *matHeaderCellDef></th>
          <td class="mat-cell"  center mat-cell colspan="1" *matCellDef="let element">{{element.myname}} </td>
        </ng-container>
        <ng-container matColumnDef="filetype">
          <th class="mat-header-cell" center mat-header-cell *matHeaderCellDef> File Type </th>
          <td class="mat-cell" center mat-cell *matCellDef="let element">{{element.filetype}} </td>
        </ng-container>
        <ng-container matColumnDef="size">
          <th class="mat-header-cell" center mat-header-cell *matHeaderCellDef>Size </th>
          <td class="mat-cell"  center mat-cell *matCellDef="let element"> {{ element.size | storageMb }}</td>
        </ng-container>
        <ng-container  matColumnDef="description">
          <th class="mat-header-cell" center mat-header-cell *matHeaderCellDef> </th>
          <td class="mat-cell" center mat-cell colspan="1" *matCellDef="let element"> {{element.description}} </td>
        </ng-container>
        <ng-container  matColumnDef="actions">
          <th class="mat-header-cell" center mat-header-cell *matHeaderCellDef></th>
          <td class="mat-cell" center mat-cell *matCellDef="let row; index as i;">
            <button type="button" colspan="1" class="btn" (click)="preview(row)"> <mat-icon svgIcon="pinvoke"></mat-icon></button>
          </td>
        </ng-container>
        <ng-container  matColumnDef="deletions">
          <th class="mat-header-cell"  mat-header-cell *matHeaderCellDef></th>
          <td class="mat-cell"  mat-cell *matCellDef="let row">
            @if(dbService.previewdImageUrlMap.has(row.id)) {
              <mat-radio-group #remove (change)="onRemoveSelected($event, row.id)">
                <mat-radio-button color="primary"  value="archive">
                    Archive
                </mat-radio-button>
                <mat-radio-button color="warn" value="delete">
                    Delete
                </mat-radio-button>
                @if(showDelArchiveSelectMap.has(row.id)){
                  <mat-radio-button color="warn" value="cancel">
                    Cancel
                  </mat-radio-button>
                }
                 
              </mat-radio-group>
              <div>
              @switch(showCheckboxSelectMap.has(row.id)) {
                @case(true){
                  @switch(showCheckboxSelectMap.get(row.id)){
                    @case(true){
                      <mat-checkbox class="primary" checked disabled></mat-checkbox>
                      <button type="button" colspan="1" class="btn" (click)="delete(row.id)"><mat-icon>delete</mat-icon></button>
                    }
                    @case(false){
                      <div class="text-danger">Please select either Archive or Delete option</div>
                      <!--mat-checkbox  class="warn" disabled></mat-checkbox-->
                    }
                  }
                }
               
              }
              
              </div>
            } 
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
      </div>
      <ng-template #successfullySave>
      <div class="container">
      <h2 mat-dialog-title>Success</h2>
      <mat-dialog-content>
        <p>Successfully saved changes.</p>
       </mat-dialog-content>
      <mat-dialog-actions align="end">
        <button mat-button mat-dialog-close>Close</button>
      </mat-dialog-actions>
      </div>
    </ng-template>
    
